import { Box, useMediaQuery } from '@mui/material'
import React from 'react'
import UserNavbar from './UserNavbar'
import { Outlet } from 'react-router-dom'

const UserDashboard = () => {
  const isMobile = useMediaQuery("(max-width: 750px)");
  return (
    <Box className='App'>
      <UserNavbar />
      <Box sx={{px: isMobile ? 1 : 7}}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default UserDashboard
